// src/components/ContentViews/StarterPanel.js
import React from 'react';
import PillButton from '../elements/PillButton';
import useExploreStore from '../../contexts/useExploreStore';

const StarterPanel = () => {
  const options = ['Best coffee near me', "What's around me", '30 minute walk'];
  const { setCurrentQuery } = useExploreStore();

  const handleClick = (option) => {
    setCurrentQuery(option);
  };

  return (
    <div className="flex flex-col h-full w-full p-4">
      <div className="flex justify-end">
        {/* Removed NewQuestionButton */}
      </div>
      <div className="flex flex-col items-center space-y-4 mt-6">
        {options.map((option) => (
          <PillButton key={option} label={option} onClick={() => handleClick(option)} />
        ))}
      </div>
    </div>
  );
};

export default StarterPanel;
